/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Audit_MetadataInputs */

const en_no_audit_metadata = /** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No audit metadata`)
};

const es_no_audit_metadata = /** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin metadatos de auditoría`)
};

const fr_no_audit_metadata = /** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune métadonnée d'audit`)
};

const de_no_audit_metadata = /** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Audit-Metadaten`)
};

const id_no_audit_metadata = /** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada metadata audit`)
};

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const ja_no_audit_metadata = en_no_audit_metadata;

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const zh_no_audit_metadata = en_no_audit_metadata;

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const ar_no_audit_metadata = en_no_audit_metadata;

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const it_no_audit_metadata = en_no_audit_metadata;

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const ru_no_audit_metadata = en_no_audit_metadata;

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const pt_no_audit_metadata = en_no_audit_metadata;

/** @type {(inputs: No_Audit_MetadataInputs) => LocalizedString} */
const ko_no_audit_metadata = en_no_audit_metadata;

/**
* | output |
* | --- |
* | "No audit metadata" |
*
* @param {No_Audit_MetadataInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_audit_metadata = /** @type {((inputs?: No_Audit_MetadataInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Audit_MetadataInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_audit_metadata(inputs)
	if (locale === "es") return es_no_audit_metadata(inputs)
	if (locale === "fr") return fr_no_audit_metadata(inputs)
	if (locale === "de") return de_no_audit_metadata(inputs)
	if (locale === "ja") return ja_no_audit_metadata(inputs)
	if (locale === "zh") return zh_no_audit_metadata(inputs)
	if (locale === "ar") return ar_no_audit_metadata(inputs)
	if (locale === "id") return id_no_audit_metadata(inputs)
	if (locale === "it") return it_no_audit_metadata(inputs)
	if (locale === "ru") return ru_no_audit_metadata(inputs)
	if (locale === "pt") return pt_no_audit_metadata(inputs)
	return ko_no_audit_metadata(inputs)
});